import React, { useEffect, useState } from 'react'
import "./ProductOrderBox.css"
import { Col, Container, Modal, Row, Toast, ToastContainer } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import axios from 'axios'
import StarRatings from 'react-star-ratings'
import { useLocation } from 'react-router-dom'
function ProductOrderBox({ items, state,order }) {
    const location=useLocation();
      const { currentLocal } = useSelector((state) => state.currentLocal);

    const [show, setShow] = useState(false)
    const [alert, setAlert] = useState('')
    const [rating, setRating] = useState();
    const [comment, setComment] = useState();
    const [showRatingModel, setShowRatingModel] = useState(false);
    const userinfo = useSelector((state) => state);
console.log(items && items);

    return (
        <div className='product_order_box'>
            <ToastContainer
                className="p-3"
                position={'bottom-end'}
                style={{ zIndex: 1000000000000000000, position: 'fixed' }}
                backgroundColor={'success'}
            >
                <Toast onClose={() => setShow(false)} show={show} bg={"success"} delay={5000} autohide>
                    <Toast.Header className='d-flex justify-content-between border-0 py-0 bg-transparent border-bpttom'>
                        <p></p>
                        <img
                            src="holder.js/20x20?text=%20"
                            className="rounded me-2"
                            alt=""
                        />
                    </Toast.Header>
                    <Toast.Body className='text-center text-white'>{alert}</Toast.Body>
                </Toast>
            </ToastContainer>
{location.pathname.includes('order')?
 items && items.map((item, index) => {
                console.log(item);
                
                return (
                    <Container fluid className='mb-3' key={index}>
                        <Modal
                            show={showRatingModel}
                            onHide={() => setShowRatingModel(false)}
                            size="md"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            className='edit_model'
                            scrollable
                        >
                            <Modal.Header closeButton className='py-1 border-bottom-0'>

                            </Modal.Header>
                            <Modal.Body>

                                <div className='border-bottom py-2'>
                                    <form onSubmit={async (e) => {
                                        e.preventDefault();
                                        await axios
                                            .post(`https://nanosoft.technology/outlaw/api/reviews`, {
                                                productId: String(item.productId),
                                                rating: rating,
                                                comment: comment
                                            }, {
                                                headers: {
                                                    Authorization: `Bearer ${userinfo.auth.access_token}`

                                                }
                                            })
                                            .then(async (res) => {
                                                setShow(true)
                                                setAlert('Review added successfully')
                                                setComment('')
                                                setRating()
                                                setShowRatingModel(false)
                                            })
                                            .catch((error) => {

                                                setShow(true)
                                                setAlert(error.response.data.error)


                                            });
                                    }}>
                              
                                        <StarRatings
                                            rating={rating}
                                            starRatedColor="#e9ba17"
                                            numberOfStars={5}
                                            name='rating'
                                            isSelectable={true}
                                            starDimension="25px"
                                            starSpacing="2px"
                                            changeRating={(newRating, name) => setRating(newRating)}

                                        />
                                        <textarea
                                            placeholder='Your comment '
                                            className='mb-3 bg-muted py-1 px-2 w-100 border-0 mt-4'
                                            style={{ backgroundColor: '#F1F4FE', borderRadius: '7px' }}
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                        >

                                        </textarea>
                                        <div className='w-100 d-flex justify-content-center'>
                                            <button className='w-50 bg-primary text-white py-2 ' type='submit'>Rate</button>

                                        </div>
                                    </form>
                                </div>

                            </Modal.Body>
                        </Modal>
                        {/* {location.pathname.includes('order')&&
                        order&&order?.status?.id==5&&
                        <Row>
                            <div className='d-flex justify-content-end ' >
                                <p
                                    style={{
                                        border: "1px solid #004CFF",
                                        fontSize: "14px",
                                        color: "#004CFF",
                                        borderRadius: "9px",
                                        cursor: "pointer"

                                    }}
                                    className='px-2 py-1'
                                    onClick={() => setShowRatingModel(true)}
                                >Review</p>
                            </div>
                        </Row>
            } */}
                        <Row className='d-flex justify-content-between align-items-center '>
                            <Col md={8} className='d-flex'>
                                <div className='me-3 w-25'>
                                    <img src={item.product?.images && item.product?.images[0]?.image} alt="" className="w-100" />

                                </div>
                                <div>
                                    <span className='product_name '>{state === "order" ?currentLocal.language==="English"?item.product.name_en: item.product.name_ar?.substring(0, 12) : item.product_name?.substring(0, 12)}...</span>
                                    <br />
                                    {/* <span className='product_color'>{state === "order" ? item.color : item.product.color}</span> */}
                                    {/* <br />
                                    <span className='product_size'>Size: {state === "order" ? item.size : item.product.size}</span> */}
                                    <span className='product_size'>Quintity: {state === "order" ? item?.quantity : item.quantity} * {state === "order" ?item?.product.discounted_price_egp:item&&item.discounted_price_egp} LE</span>

                                </div>


                            </Col>

                            <Col md={4}>
                                <div className='price fw-bold text-center'>
                                    LE {state === "order" ? item.total : item.total_price_egp}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                )
            })

:
 items && items?.products?.map((item, index) => {
                console.log(item.product?.images[0]?.image);
                
                return (
                    <Container fluid className='mb-3' key={index}>
                        <Modal
                            show={showRatingModel}
                            onHide={() => setShowRatingModel(false)}
                            size="md"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            className='edit_model'
                            scrollable
                        >
                            <Modal.Header closeButton className='py-1 border-bottom-0'>

                            </Modal.Header>
                            <Modal.Body>

                                <div className='border-bottom py-2'>
                                    <form onSubmit={async (e) => {
                                        e.preventDefault();
                                        await axios
                                            .post(`https://nanosoft.technology/outlaw/api/reviews`, {
                                                productId: String(item.productId),
                                                rating: rating,
                                                comment: comment
                                            }, {
                                                headers: {
                                                    Authorization: `Bearer ${userinfo.auth.access_token}`

                                                }
                                            })
                                            .then(async (res) => {
                                                setShow(true)
                                                setAlert('Review added successfully')
                                                setComment('')
                                                setRating()
                                                setShowRatingModel(false)
                                            })
                                            .catch((error) => {

                                                setShow(true)
                                                setAlert(error.response.data.error)


                                            });
                                    }}>
                              
                                        <StarRatings
                                            rating={rating}
                                            starRatedColor="#e9ba17"
                                            numberOfStars={5}
                                            name='rating'
                                            isSelectable={true}
                                            starDimension="25px"
                                            starSpacing="2px"
                                            changeRating={(newRating, name) => setRating(newRating)}

                                        />
                                        <textarea
                                            placeholder='Your comment '
                                            className='mb-3 bg-muted py-1 px-2 w-100 border-0 mt-4'
                                            style={{ backgroundColor: '#F1F4FE', borderRadius: '7px' }}
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                        >

                                        </textarea>
                                        <div className='w-100 d-flex justify-content-center'>
                                            <button className='w-50 bg-primary text-white py-2 ' type='submit'>Rate</button>

                                        </div>
                                    </form>
                                </div>

                            </Modal.Body>
                        </Modal>
                        {location.pathname.includes('order')&&
                        order&&order.status==="DELIVERED"&&
                        <Row>
                            <div className='d-flex justify-content-end ' >
                                <p
                                    style={{
                                        border: "1px solid #004CFF",
                                        fontSize: "14px",
                                        color: "#004CFF",
                                        borderRadius: "9px",
                                        cursor: "pointer"

                                    }}
                                    className='px-2 py-1'
                                    onClick={() => setShowRatingModel(true)}
                                >Review</p>
                            </div>
                        </Row>
            }
                        <Row className='d-flex justify-content-between align-items-center '>
                            <Col md={8} className='d-flex'>
                                <div className=' w-50'>
                                    <img src={item.product?.images && item.product?.images[0]?.image} alt="" className="w-100" />

                                </div>
                                <div>
                                    <span className='product_name '>{state === "order" ? item.product.product_name?.substring(0, 12) :currentLocal?.language === "English"? item.product?.name_en:item.product?.name_ar?.substring(0, 12)}...</span>
                                    <br />
                                    {/* <span className='product_color'>{state === "order" ? item.color : item.product.color}</span> */}
                                    {/* <br />
                                    <span className='product_size'>Size: {state === "order" ? item.size : item.product.size}</span> */}
                                    <span className='product_size'>Quintity: {state === "order" ? item.products.quantity : item.quantity} * {item&&item.discounted_price_egp} LE</span>

                                </div>


                            </Col>

                            <Col md={4}>
                                <div className='price fw-bold text-center'>
                                    LE {state === "order" ? item.total_price_egp : item.total_price_egp}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                )
            })
}
           



        </div>
    )
}

export default ProductOrderBox